module.exports = __webpack_public_path__ + "img/game--battlefield-2042--pegi.d68d4d4a.png";